import React from 'react';

const CSS = require('./WithlocalsLogoSmall.module.scss');

interface WithlocalsLogoSmallProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

function WithlocalsLogoSmall({
  width = 48,
  height = 25,
  color = undefined,
  ...rest
}: WithlocalsLogoSmallProps) {
  // tslint:disable max-line-length
  return (
    <svg width={width} height={height} {...rest} viewBox="0 0 48 25">
      <g fill={!!color ? color : '#8B174E'}>
        <path
          className={CSS.FillTransition}
          d="m31.439 11.478c-0.98513 0-1.7831-0.79878-1.7831-1.7839 0-0.98513 0.79793-1.7839 1.7831-1.7839 0.98598 0 1.7848 0.79878 1.7848 1.7839 0 0.98513-0.79878 1.7839-1.7848 1.7839zm3.4755-11.478c6.9755 0 12.63 5.6541 12.63 12.63 0 6.9747-5.655 12.63-12.63 12.63-4.1641 0-7.8573-2.0152-10.159-5.123 0.66494-1.0715 1.1884-2.2286 1.5493-3.4399 1.5256 3.2231 4.8071 5.4534 8.6095 5.4534 5.2577 0 9.5201-4.2624 9.5201-9.5201 0-5.2585-4.2624-9.5209-9.5201-9.5209-4.9663 0-9.0449 3.8033-9.4811 8.6552-0.023718 0.29986-0.048282 0.58786-0.075388 0.86569-0.10588 0.87501-0.22193 1.8407-0.45064 2.9774-1.3384 5.5381-6.3275 9.6522-12.277 9.6522-6.9755 0-12.63-5.655-12.63-12.63 0-6.9764 5.655-12.63 12.63-12.63 4.1641 0 7.8573 2.0152 10.159 5.123-0.66494 1.0715-1.1884 2.2286-1.5493 3.4399-1.5256-3.2231-4.8071-5.4534-8.6095-5.4534-5.2577 0-9.5201 4.2624-9.5201 9.5209 0 5.2577 4.2624 9.5201 9.5201 9.5201 4.9663 0 9.044-3.8024 9.4811-8.6552 0.023718-0.29986 0.048282-0.58786 0.075388-0.86485 0.10588-0.87671 0.22193-1.8415 0.45064-2.9783 1.3384-5.5389 6.3275-9.6522 12.277-9.6522zm-5.5415 14.228c0-0.26428 0.23633-0.48028 0.52602-0.48028h10.011c0.28885 0 0.52602 0.216 0.52602 0.48028 0 3.0553-2.4768 5.5321-5.5313 5.5321-3.0553 0-5.5313-2.4768-5.5313-5.5321zm10.526-4.5335c0 0.98513-0.79878 1.7839-1.7839 1.7839-0.98513 0-1.7839-0.79878-1.7839-1.7839 0-0.98513 0.79878-1.7839 1.7839-1.7839 0.98513 0 1.7839 0.79878 1.7839 1.7839zm-32.801 4.5335c0-0.26428 0.23633-0.48028 0.52602-0.48028h10.011c0.28885 0 0.52602 0.216 0.52602 0.48028 0 3.0553-2.4768 5.5321-5.5313 5.5321s-5.5313-2.4768-5.5313-5.5321zm10.705-4.5335c0 0.98513-0.79878 1.7839-1.7839 1.7839s-1.7839-0.79878-1.7839-1.7839c0-0.98513 0.79878-1.7839 1.7839-1.7839s1.7839 0.79878 1.7839 1.7839zm-8.4596 1.7839c-0.98598 0-1.7848-0.79878-1.7848-1.7839 0-0.98513 0.79878-1.7839 1.7848-1.7839 0.98513 0 1.7831 0.79878 1.7831 1.7839 0 0.98513-0.79793 1.7839-1.7831 1.7839z"
        />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default WithlocalsLogoSmall;
